import React from 'react';

import Proptypes from 'prop-types';
import { Box, StackView, TextInput } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

const OrderPlacedRecipient = ({
  orderPlacedRecipients,
  setOrderPlacedRecipients
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      emailDetail: { orderPlacedAddress, orderPlacedAddressDetail }
    }
  } = localizedStrings;

  return (
    <StackView space={3}>
      <TextInput
        label={orderPlacedAddress}
        hint={orderPlacedAddressDetail}
        value={orderPlacedRecipients}
        onChange={(value) => setOrderPlacedRecipients(value)}
      />
    </StackView>
  );
};

OrderPlacedRecipient.propTypes = {
  orderPlacedRecipients: Proptypes.string.isRequired,
  setOrderPlacedRecipients: Proptypes.func.isRequired
};

export default OrderPlacedRecipient;
